import { Save, Check, Loader2 } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ar } from 'date-fns/locale';

interface AutoSaveIndicatorProps {
  lastSaved: Date | null;
  isSaving: boolean;
  onManualSave?: () => void;
}

export const AutoSaveIndicator = ({ lastSaved, isSaving, onManualSave }: AutoSaveIndicatorProps) => {
  return (
    <div className="flex items-center gap-2 text-sm">
      {isSaving ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin text-blue-500" />
          <span className="text-muted-foreground">جاري الحفظ...</span>
        </>
      ) : lastSaved ? (
        <>
          <Check className="w-4 h-4 text-green-500" />
          <span className="text-muted-foreground">
            آخر حفظ: {formatDistanceToNow(lastSaved, { addSuffix: true, locale: ar })}
          </span>
        </>
      ) : (
        <span className="text-muted-foreground">لم يتم الحفظ بعد</span>
      )}
      
      {onManualSave && !isSaving && (
        <button
          onClick={onManualSave}
          className="flex items-center gap-1 px-3 py-1 text-xs bg-primary/10 hover:bg-primary/20 text-primary rounded-md transition-colors"
        >
          <Save className="w-3 h-3" />
          حفظ الآن
        </button>
      )}
    </div>
  );
};
